module.exports = __webpack_public_path__ + "img/16l006-01.37e2e43c.png";